export const WALLET_RATES = {
  CREATION_CHARGE: 500,
  INSTALLMENT_CHARGE: 40,
  get MIN_BALANCE() {
    return WALLET_RATES.CREATION_CHARGE;
  },
  LOW_BALANCE_THRESHOLD: 500,
};

// One-time KYC verification fee, deducted from the wallet on submission.
export let KYC_FEE = 2000;

export function setWalletRates(creation: number, installment: number, lowBalanceThreshold: number) {
  WALLET_RATES.CREATION_CHARGE = creation;
  WALLET_RATES.INSTALLMENT_CHARGE = installment;
  WALLET_RATES.LOW_BALANCE_THRESHOLD = lowBalanceThreshold;
}

export function setKycFee(v: number) {
  KYC_FEE = v;
}